import * as React from "react";
const SvgFiRrDashboard = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-dashboard_svg__a)">
      <path
        fill="#062147"
        d="M23.9 11.437A12 12 0 0 0 0 13a11.88 11.88 0 0 0 3.76 8.712A4.84 4.84 0 0 0 7.112 23h9.767a5 5 0 0 0 3.51-1.43 11.94 11.94 0 0 0 3.51-10.133m-4.909 8.7a3 3 0 0 1-2.11.863H7.112c-.73.015-1.44-.25-1.98-.741A9.9 9.9 0 0 1 2 12.999a10.01 10.01 0 0 1 3.338-7.456A9.88 9.88 0 0 1 11.986 3q.588 0 1.174.066a9.994 9.994 0 0 1 5.831 17.076zM7.807 17.285a1 1 0 1 1-1.4 1.43A8 8 0 0 1 13.143 5.08a1 1 0 0 1 .847 1.133.987.987 0 0 1-1.133.848 6 6 0 0 0-5.05 10.223m12.112-5.428a8.1 8.1 0 0 1-.541 4.246 7.9 7.9 0 0 1-1.786 2.613 1.002 1.002 0 0 1-1.4-1.432 5.98 5.98 0 0 0 1.744-5.141 1 1 0 1 1 1.981-.286zm-5.993.63a2.033 2.033 0 1 1-1.414-1.413l3.781-3.781a1 1 0 1 1 1.414 1.414z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-dashboard_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDashboard;
